import React from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {DeleteBotoomSheet} from '..';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
interface DeleteAdverTismentProps {
  deleteItem: DeleteBotoomSheet;
  mutateFunction: () => void;
  setDeleteItem: React.Dispatch<React.SetStateAction<DeleteBotoomSheet>>;
}
const DeleteAdverTisment = ({
  deleteItem,
  setDeleteItem,
  mutateFunction,
}: DeleteAdverTismentProps) => {
  return (
    <BottomSheet
      onDismiss={() => {
        setDeleteItem({isOpen: false, data: null});
      }}
      open={deleteItem.isOpen}
      blocking={true}
      className="transition ease-in-out delay-250 "
    >
      <div className="w-full flex flex-col gap-2 p-3">
        <div className="flex w-full justify-between">
          <p className="text-md font-Regular">حذف آگهی</p>
          <SpanIcon
            className="icon-nameClose-remove text-xl"
            onClick={() => setDeleteItem({isOpen: false, data: null})}
          />
        </div>
        <p className="text-sm font-Regular">
          آیا اطمینان به حذف آگهی
          <span className="text-md font-DemiBold">
            {' '}
            {deleteItem.data?.title}{' '}
          </span>
          دارید؟
        </p>
        <div className="w-full flex justify-between gap-2 items-center text-md font-Medium">
          <button
            className="w-[70%] bg-red-500 h-[48px] text-white text-md rounded-[8px] font-Medium"
            onClick={() => {
              mutateFunction();
            }}
          >
            بله، حذف
          </button>
          <button
            className="w-[30%] text-farm-shop-500 h-[48px] text-md font-Medium border border-farm-shop-500 rounded-[8px]"
            onClick={() => setDeleteItem({isOpen: false, data: null})}
          >
            خیر
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default DeleteAdverTisment;
